<template>
  <div>
    <v-tooltip :disabled="!userSettings.showTooltips || filterLines.length == 0" bottom style="z-index: 10">
      <template v-slot:activator="{ on }">
        <div v-on="on">
          <t-button :class="isOnMobile ? 'pa-1' : 'pa-2'" :btnDisabled="btnDisabled" :btnText="(isOnMobile ? '' : s_Filters) + filtersCount" :btnIcon="'mdi-filter-variant'" @click="showFilters()" />
        </div>
      </template>
      <v-row class="ma-0 pa-0" v-for="(line, idx) in filterLines" :key="idx" :color="isInDarkMode ? 'rgba(0,0,0,1)' : ''">{{ line }}</v-row>
    </v-tooltip>
  </div>
</template>

<script>
import DataManager from "../../js/DataManager";
import bus, { TR } from "../../main";

export default {
  props: {
    datatype: null,
    btnDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      reload: false,
      filtersCount: "",
      filterLines: [],
      s_Filters: TR.Filters,
    };
  },
  computed: {},
  methods: {
    showFilters() {
      // if (this.datatype) this.dialog.show(g_Dialog.dialog_types.filter_view, this.datatype);
    },
  },
  mounted() {
    bus.$on(bus.EVENT_DataManager_FILTERS_CHANGED, (datatype) => {
      if (datatype == this.datatype) {
        this.filtersCount = DataManager.getFilters(this.datatype.id).length == 0 ? "" : " (" + DataManager.getFilters(this.datatype.id).length + ")";
        this.filterLines = DataManager.getFilterLines(this.datatype.id);
      }
    });
  },
  created() {},
};
</script>
